module.exports = __webpack_public_path__ + "media/images/logos/windeurope-annual2024-e774bd5e916977ced81a7a47b9da9d90.svg";